export default "__VITE_ASSET__DAZGFxY1__"